
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        isScrolled
          ? 'bg-deep-green/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/4b33f3b8-427f-4570-abed-0966eedfc6e3.png"
              alt="PLADUREX Logo"
              className="h-12 w-auto"
            />
            <span className="text-2xl font-bold text-primary-yellow">PLADUREX</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[15px] font-medium transition-colors relative whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-yellow'
                    : 'text-text-light hover:text-primary-yellow'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <motion.div
                    layoutId="activeNav"
                    className="absolute -bottom-1 left-0 right-0 h-0.5 bg-primary-yellow"
                  />
                )}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+34629501941"
              className="px-5 py-2.5 bg-primary-yellow text-deep-green font-semibold rounded-lg hover:shadow-[0_0_20px_rgba(255,212,0,0.4)] transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Llamar
            </a>
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 border-2 border-primary-yellow text-primary-yellow font-semibold rounded-lg hover:bg-primary-yellow hover:text-deep-green transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-text-light text-2xl w-10 h-10 flex items-center justify-center"
            aria-label="Toggle menu"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden mt-4 pb-4 border-t border-card-green/50 pt-4"
          >
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`text-[15px] font-medium py-2 px-4 rounded-lg transition-colors ${
                    location.pathname === link.path
                      ? 'bg-primary-yellow text-deep-green'
                      : 'text-text-light hover:bg-card-green'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col gap-2 mt-2">
                <a
                  href="tel:+34629501941"
                  className="px-5 py-3 bg-primary-yellow text-deep-green font-semibold rounded-lg text-center flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-phone-line"></i>
                  Llamar
                </a>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-5 py-3 border-2 border-primary-yellow text-primary-yellow font-semibold rounded-lg text-center flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line"></i>
                  WhatsApp
                </a>
              </div>
            </nav>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;
